import { Link } from "react-router-dom";
import { Asterisk } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t-2 border-charcoal bg-charcoal text-cream">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
          <div>
            <Link to="/" className="flex items-center gap-1 font-display text-4xl font-extrabold uppercase tracking-tight">
              Stay Retro <Asterisk className="h-7 w-7 text-mint" strokeWidth={3} />
            </Link>
            <p className="mt-3 max-w-sm font-mono text-xs leading-relaxed text-cream/70">
              Curated analog artifacts from the 80s, 90s and Y2K. No inventory, no cart, no checkout. Just the good stuff, linked.
            </p>
          </div>
          <nav className="flex gap-16">
            <div className="flex flex-col gap-3">
              <span className="font-mono text-xs uppercase text-mint">Shop</span>
              <Link to="/shop" data-testid="footer-shop-link" className="font-display text-sm font-bold uppercase hover:text-yellow">All Products</Link>
              <Link to="/shop?era=1980s" data-testid="footer-80s-link" className="font-display text-sm font-bold uppercase hover:text-yellow">1980s</Link>
              <Link to="/shop?era=1990s" data-testid="footer-90s-link" className="font-display text-sm font-bold uppercase hover:text-yellow">1990s</Link>
              <Link to="/shop?era=2000s" data-testid="footer-y2k-link" className="font-display text-sm font-bold uppercase hover:text-yellow">Y2K</Link>
            </div>
            <div className="flex flex-col gap-3">
              <span className="font-mono text-xs uppercase text-mint">Site</span>
              <Link to="/about" data-testid="footer-about-link" className="font-display text-sm font-bold uppercase hover:text-yellow">About</Link>
            </div>
          </nav>
        </div>
        <div data-testid="footer-disclosure" className="mt-12 rounded-2xl border-2 border-cream/30 p-5">
          <p className="font-mono text-xs leading-relaxed text-cream/80">
            AFFILIATE DISCLOSURE: Stay Retro is a curated storefront, not a shop. We hold no inventory and process no payments.
            Every Buy button links to an external retailer, and we may earn a commission on qualifying purchases at no extra cost to you.
            Prices shown are a guide — always check the retailer for the current price and condition.
          </p>
        </div>
        <div className="mt-8 flex flex-col items-start justify-between gap-3 border-t border-cream/20 pt-6 sm:flex-row sm:items-center">
          <span className="font-mono text-xs text-cream/60">© 2026 STAY RETRO — BUILT DIFFERENT</span>
          <span className="font-mono text-xs text-cream/60">ANALOG IS BACK. TOUCH GRASS, PRESS BUTTONS.</span>
        </div>
      </div>
    </footer>
  );
}
